(function () {
  var nav = document.querySelector('[data-matang-nav]');
  if (!nav) return;

  var items = nav.querySelectorAll('[data-matang-nav-item]');

  function closeAll() {
    items.forEach(function (item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.matang-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
      var mega = item.querySelector('.matang-mega');
      if (mega) mega.style.removeProperty('--mega-shift');
    });
  }

  items.forEach(function (item) {
    var link = item.querySelector('.matang-nav__link');
    var mega = item.querySelector('.matang-mega');
    if (!link || !mega) return;

    link.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = item.classList.contains('is-open');
      closeAll();
      if (!isOpen) {
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
        keepMegaInViewport(mega);
      }
    });

    link.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
        link.blur();
      }
    });
  });

  /**
   * Keeps a mega panel from overflowing the left/right edge of the viewport.
   * The panel is centered on its trigger by default (see CSS); this only
   * nudges it back on-screen via the --mega-shift custom property when that
   * default centering would push it past the viewport edge.
   */
  function keepMegaInViewport(mega) {
    mega.style.setProperty('--mega-shift', '0px');
    var margin = 16;
    var rect = mega.getBoundingClientRect();
    var shift = 0;
    if (rect.left < margin) {
      shift = margin - rect.left;
    } else if (rect.right > window.innerWidth - margin) {
      shift = (window.innerWidth - margin) - rect.right;
    }
    if (shift !== 0) {
      mega.style.setProperty('--mega-shift', shift + 'px');
    }
  }

  document.addEventListener('click', function (event) {
    if (!nav.contains(event.target)) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', function () {
    var openItem = nav.querySelector('[data-matang-nav-item].is-open');
    if (!openItem) return;
    var mega = openItem.querySelector('.matang-mega');
    if (mega) keepMegaInViewport(mega);
  });

  /* ---- Mobile accordion ---- */
  var mobileToggle = nav.querySelector('[data-matang-mobile-toggle]');
  var mobilePanel = nav.querySelector('[data-matang-mobile-panel]');

  if (mobileToggle && mobilePanel) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobilePanel.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    var groups = mobilePanel.querySelectorAll('[data-matang-mobile-group]');
    groups.forEach(function (group) {
      var toggle = group.querySelector('.matang-nav__mobile-group-toggle');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        group.classList.toggle('is-open');
      });
    });
  }
})();
